import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - var(--top-navigation-height) - 50px);
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fonts["3xl"].fontSize};
  color: ${({ theme }) => theme.colors.text.primary.color};
  font-weight: 700;
  padding-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  color: ${({ theme }) => theme.colors.text.primary.color};
`;
